import { render, staticRenderFns } from "./PlaygroundIA.vue?vue&type=template&id=6b8e63e9"
import script from "./playground/PlaygroundIA.js?vue&type=script&lang=js&external"
export * from "./playground/PlaygroundIA.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports